










import HeaderWrapper from "@co/HeaderWrapper/index.vue";
import Editor from "@co/Editor/index.vue";
import PreviewImage from "@co/PreviewImage/index.vue";
import MyFooter from "@co/MyFooter/index.vue";
import Vue from "vue";

//import images from "@/utils/images";
//import { cloneDeep } from "lodash";
export default Vue.extend({
  components: {
    HeaderWrapper,
    Editor,
    PreviewImage,
    MyFooter,
  },
});
